// Preserve the MIME returned by Aria's TTS endpoint when turning bytes into a
// data URL. Edge returns MP3; labeling those bytes as WAV makes Chromium reject
// the otherwise-valid local-reply audio.
export function audioDataUrlFromArrayBuffer(buffer, contentType) {
  if (!buffer || !buffer.byteLength) return '';
  const rawType = String(contentType || '').split(';', 1)[0].trim().toLowerCase();
  const mime = /^audio\/[a-z0-9.+-]+$/.test(rawType) ? rawType : 'audio/wav';
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let index = 0; index < bytes.length; index += 1) binary += String.fromCharCode(bytes[index]);
  return `data:${mime};base64,${btoa(binary)}`;
}
